import PropTypes from 'prop-types';
import React from 'react';
import get from 'lodash/get';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, defineMessages } from 'react-intl';
import './styles.css';
import Message from '../../components/Message';
import Icon from '../../components/Icon';

export const messages = defineMessages({
  syncNavHeaderText: {
    id: 'repvisits.setupWizard.syncNavHeaderText',
    defaultMessage: 'Naviance Settings Not Yet Complete',
  },
  syncNavText: {
    id: 'repvisits.setupWizard.syncNavText',
    defaultMessage: 'Please complete all remaining wizard steps.',
  },
});

class NavianceSyncMessage extends React.Component {
  static propTypes = {
    viewer: PropTypes.object,
    history: PropTypes.shape({
      location: PropTypes.object.isRequired,
    }).isRequired,
    children: PropTypes.node,
  };

  static defaultProps = {
    children: null,
  };

  render() {
    const { children, viewer, history } = this.props;
    const isCurrentlyViewingNavianceSetup = history.location.pathname === '/rep-visits/setup/naviance';
    const navianceSetupComplete = get(viewer, 'repVisitsAccount.navianceSetupComplete', false);
    const navianceOptedIn = get(viewer, 'repVisitsAccount.navianceSettings.optIn', false);
    if (!viewer.isNavianceLogin || !isCurrentlyViewingNavianceSetup || !navianceOptedIn || navianceSetupComplete) {
      return children;
    } else {
      return (
        <Message warning size="small" icon className="toast persistent" styleName="Nav-banner">
          <Icon name="exclamation circle" styleName="Nav-banner-icon" />
          <Message.Content>
            <b>
              <FormattedMessage {...messages.syncNavHeaderText} />
            </b>
            <span styleName="alignNavText">
              <FormattedMessage {...messages.syncNavText} />
            </span>
          </Message.Content>
        </Message>
      );
    }
  }
}

export default withRouter(NavianceSyncMessage);
